require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-lgm-ws.json") })
        }
      }, "path---photos-professional-lgm-ws");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-lgm-ws!./.cache/json/photos-professional-lgm-ws.json
// module id = 818
// module chunks = 231608221292675